export default {"src":"/_next/static/media/boomgardi.9ea217d5.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};